export default __webpack_public_path__ + "static/media/noimage.8fe5d4cb.jpg";